import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, collection, addDoc, getDoc, onSnapshot } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { useStore } from './store';

const firebaseConfig = {
  apiKey: "AIzaSyBWL7I8psZez4rax24y-A7NnQHkPHUK1Fg",
  authDomain: "teaching-assistant-47169.firebaseapp.com",
  projectId: "teaching-assistant-47169",
  storageBucket: "teaching-assistant-47169.firebasestorage.app",
  messagingSenderId: "196526898401",
  appId: "1:196526898401:web:23c4307631acfe49314ba0",
  measurementId: "G-MVFGPB9BJC"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

export const saveContext = async (userId: string, context: any) => {
  await setDoc(doc(db, `users/${userId}/contexts/teaching`), context);
};

export const savePrompt = async (userId: string, type: string, content: string) => {
  const promptRef = doc(db, `users/${userId}/prompts/${type}`);
  const promptDoc = await getDoc(promptRef);
  
  if (!promptDoc.exists()) {
    const defaultPrompts: Record<string, string> = {
      reel: `Create a 45-second script that opens with a hook, delivers a clear message, and ends with a call-to-action. Keep it conversational and natural.`,
      long: `Write a long-form post that starts with a thought-provoking hook, builds a personal narrative, and shares actionable insights. Balance authority with relatability.`,
      short: `Craft a bold, impactful statement under 130 characters that captures the key insight and sparks engagement. Keep it simple but powerful.`
    };
    
    await setDoc(promptRef, { content: defaultPrompts[type] || content });
    return defaultPrompts[type] || content;
  }
  
  if (content) {
    await setDoc(promptRef, { content });
  }
  
  return promptDoc.data()?.content || '';
};

export const saveTeaching = async (userId: string, teaching: any) => {
  await addDoc(collection(db, `users/${userId}/teachings`), teaching);
};

export const saveApiKeys = async (userId: string, keys: { openai: string; elevenlabs: string }) => {
  await setDoc(doc(db, `users/${userId}/settings/api`), {
    openai: keys.openai,
    elevenlabs: keys.elevenlabs
  });
};

export const loadApiKeys = async (userId: string) => {
  const apiDoc = await getDoc(doc(db, `users/${userId}/settings/api`));
  if (!apiDoc.exists()) return null;
  return apiDoc.data() as { openai: string; elevenlabs: string };
};

export const subscribeToApiKeys = (userId: string, callback: (keys: { openai: string; elevenlabs: string } | null) => void) => {
  const unsubscribe = onSnapshot(
    doc(db, `users/${userId}/settings/api`),
    (doc) => {
      if (doc.exists()) {
        callback(doc.data() as { openai: string; elevenlabs: string });
      } else {
        callback(null);
      }
    },
    (error) => {
      console.error('Error subscribing to API keys:', error);
      callback(null);
    }
  );
  
  return unsubscribe;
};